// Conditional-rendering predicate evaluator for questions (copied from Recover
// Configure). Deflect's steps are currently unconditional, but the framework
// (validation / progress) calls visibleQuestions, so it ships with the wizard.

const getDeep = (obj, path) => {
  if (!path || !obj) return undefined
  return path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj)
}

export const evalShowIf = (predicate, buildingBlocks) => {
  if (predicate == null) return true
  if (Array.isArray(predicate)) return predicate.every((p) => evalShowIf(p, buildingBlocks))
  if (predicate.any) return predicate.any.some((p) => evalShowIf(p, buildingBlocks))
  if (predicate.not) return !evalShowIf(predicate.not, buildingBlocks)
  const value = getDeep(buildingBlocks, predicate.key)
  if ("equals" in predicate) return value === predicate.equals
  if ("notEquals" in predicate) return value !== predicate.notEquals
  if ("oneOf" in predicate) return predicate.oneOf.includes(value)
  if ("includes" in predicate) return Array.isArray(value) && value.includes(predicate.includes)
  if ("includesAny" in predicate)
    return Array.isArray(value) && predicate.includesAny.some((v) => value.includes(v))
  if ("present" in predicate) {
    const present = !(value == null || value === "" || (Array.isArray(value) && value.length === 0))
    return predicate.present ? present : !present
  }
  return true
}

// `hidden` questions only carry a value through a save and are never rendered,
// validated or counted (state_region, CHA1-4846).
export const visibleQuestions = (schema, buildingBlocks) =>
  (schema || []).filter((q) => !q.hidden && evalShowIf(q.showIf, buildingBlocks))
